import { takeLatest, call, put } from "redux-saga/effects";

import apiCaller from "../../utils/apiCaller";
import {
    GET_DURATIONS_REQUEST,
    getDurationsSuccess,
    getDurationsFail
} from "../actions/durations";
import { HTTP_METHODS } from "../../config";

function* getDurations({ payload: { onSuccess, onError } }) {
  try {
    const response = yield call(apiCaller, HTTP_METHODS.GET, {
      url: "/api/admin/bet/durations",
      token: true
    });

    if (onSuccess) {
      yield call(onSuccess);
    }

    const successAction = yield call(getDurationsSuccess, {durations: response});
    yield put(successAction);
  } catch (err) {
    if (onError) {
      yield call(onError);
    }

    const errAction = yield call(getDurationsFail, err);
    yield put(errAction);
  }
}

export default function*() {
  yield takeLatest(GET_DURATIONS_REQUEST, getDurations);
}
